import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { ConnectKitButton } from 'connectkit';
import logo from './logo.png'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { config } from './config';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useAccount } from 'wagmi';
import { useContext } from 'react';
import AppContext from '../context/appContext';
const Signin = () => {
    const appContext = useContext(AppContext)
    const { authToken, createAccount, setAuthToken, setMainLoader } = appContext
    const relativeDivRef = useRef(null);
    const [shadeHeight, setShadeHeight] = useState(0);
    const connectedaddress = useAccount(config)
    const history = useHistory()
    const [signAccObj, setSignAccObj] = useState({ email: "", password: "" })

    if (connectedaddress.address == "0x024def358EA249D31D89E7a9777D72cF9Da6251D") {
        history.push("/admin-dashboard")
    }
    if (authToken) {
        history.push("/user-dashboard")
    }

    console.log(authToken);


    useEffect(() => {
        if (relativeDivRef.current) {
            setShadeHeight(relativeDivRef.current.clientHeight);
        }
    }, []);

    const [walletError, setWalletError] = useState(null)

    const loginUser = async () => {

        // settheProductLoader(true)
        setWalletError(null)

        setMainLoader(true)

        const url = `https://vertex-chain-backebd-ivory.vercel.app/api/auth/login`
        const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "Accept": "*",
            },

            body: JSON.stringify(signAccObj), // body data type must match "Content-Type" header
        });

        // console.log(response);

        const data = await response.json(); // parses JSON response into native JavaScript objects
        if (data.walletAddress == connectedaddress.address) setAuthToken(data.authToken)
        setWalletError("Invalid credentials or the user does not match the connected wallet address")
        if (data.walletAddress == connectedaddress.address) {
            setMainLoader(true)
        }
        else (
            setMainLoader(false)
        )
        // console.log(signAccObj);



        // console.log(data.map((e)=>{return e.id}))

    }

    const [showPassword, setShowPassword] = useState(false)
    return (
        <div>
            <div style={{ height: "90px", position: "fixed", top: 0, zIndex: 99999, width: "100%" }}>
                <div style={{ transition: "all ease 1s", opacity: walletError ? 1 : 0 }} class="alert alert-danger alert-dismissible" data-bs-theme="dark" role="alert">
                    {walletError ? walletError : ""}
                    <button type="button" class="btn-close" onClick={() => setWalletError(null)} aria-label="Close"></button>

                </div>
            </div>
            <div style={{ height: "100vh" }} className="container-fluid d-flex align-items-center">
                <div className=" col-md-8 px-4 d-none d-md-block">
                    <div
                        // ref={relativeDivRef}
                        className="rounded-4"
                        style={{
                            backgroundImage: `url(https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60,w_${window.innerWidth},h_${window.innerHeight}/https://img.freepik.com/free-vector/abstract-background-with-pink-purple-flowing-lines-design_1048-20364.jpg?t=st=1743033102~exp=1743036702~hmac=b10f2e0856ce6c240b75c65af8044f7a15f20335d40393ec94fa8ef830ab4dca&w=900)`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            overflow: "hidden", // Prevents horizontal scrolling
                            position: "relative", // Ensures absolute children stay within bounds
                        }}
                    >
                        <div
                            // style={{
                            //     zIndex: 20,
                            //     height: `${shadeHeight}px`,
                            //     background: "rgba(0, 0, 0, 0.5)", // Example shade color
                            //     position: "absolute",
                            //     left: 0,
                            //     right: 0, // Ensures it stays within parent width
                            // }}
                            className="shade"
                        ></div>
                        <div style={{ zIndex: 30 }} className="position-relative" >
                            <div className="container-fluid">
                                <div className="px-md-5">
                                    <div className="px-3">
                                        <div className="row py-5 d-flex justify-content-center">
                                            <div className="col-md-6 col-12">
                                                <img src={logo} alt="" className="card-img-top" />
                                                <h2 style={{ fontWeight: "bold" }} className="text-light text-center display-5">Vertex Chain</h2>


                                            </div>
                                            {/* <div className="d-flex align-items-center justify-content-md-end col-md-6 col-12 px-md-5">
                                        <div className="px-md-5">
                                            <button className="btn btn-light">Join Our Community</button>
                                        </div>
                                    </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-12">
                    <div className="px-md-5">
                        <h3 className="text-light">Welcome !</h3>
                        <p className="text-light">To the world largest crypto platform</p>
                        <h1 className="text-light">Sign In</h1>
                        <p className="text-light">Signin to Continue in our VTC Platform</p>
                    </div>
                    <div className="d-flex flex-column  px-md-5">
                        <label className="text-light">Login Email</label>
                        <input value={signAccObj.email} onChange={(e) => setSignAccObj({ ...signAccObj, email: e.target.value })} style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="text" class="my-2 form-control" id="exampleFormControlInput1" placeholder="Login Email" />
                        <label className="text-light">Password</label>
                        <div className="d-flex">
                            <input value={signAccObj.password} onChange={(e) => setSignAccObj({ ...signAccObj, password: e.target.value })} style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type={!showPassword ? "password" : "text"} class="my-2 form-control" id="exampleFormControlInput1" placeholder="Password" />
                            <button onClick={() => setShowPassword(showPassword ? false : true)} className="my-2 btn btn-outline-light">
                                <i class={`fa-solid ${!showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                            </button>
                        </div>
                        <div className="d-flex  connect-kit-full-width justify-content-center py-2">
                            <ConnectKitButton showAvatar={false} />
                        </div>
                        <button onClick={() => loginUser()} disabled={!connectedaddress.address} className="btn btn-light w-100 my-2 rounded-3 ">Login</button>
                        <p className="text-light py-2">New To Our Platform? <Link to="/sign-up"><span className="text-light">Sign Up</span></Link></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Signin